var map = {
	"./DSC06738.jpg": "f34c",
	"./act.png": "7956",
	"./banner-img-1.jpg": "bb92",
	"./banner-img-2.jpg": "3d5b",
	"./banner-img-3.jpg": "c7ea",
	"./banner-img-4.jpg": "17e5",
	"./banner-img-5.jpg": "7c1e",
	"./banner-img-6.jpg": "da41",
	"./check.png": "d8d4",
	"./crowded-motorscooter.jpg": "d15d",
	"./draggable-cart-on-wheels.jpg": "f19c",
	"./dundees-inner-city.jpg": "22be",
	"./east-harlem.jpg": "d7ea",
	"./invite.png": "84f29",
	"./kia-spectra-2008.jpg": "c06b",
	"./large-water-jugs-on-head.jpg": "b7a5",
	"./makeshift-metal.jpg": "043c",
	"./makeshift-nonmetal.jpg": "1bb7",
	"./middle-50-housing.jpg": "c547",
	"./mule.jpg": "e0d8",
	"./nice-bus-america.jpg": "203f",
	"./rickshaw-man-take-children-to-the-school-in-the-morning-in-new-delhi-d57twc.jpg": "4101",
	"./ruralindia.jpg": "ee13",
	"./sheet-metal-shack.jpg": "846e",
	"./southwest-airlines-boeing.jpg": "e081",
	"./third-world-school-bus.jpg": "eb08",
	"./top-20-photo-1.jpg": "2910",
	"./working-class-ranch-house.jpg": "be80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bec";